import React from "react";
import { Area } from "@ant-design/plots";
import { toPrice } from "../../helpers/stringFormat";

const SimpleArea = (props) => {
  const data = props.areachartdata;
  const config = {
    data,
    xField: "x",
    yField: "y",
    yAxis: {
      label: {
        formatter: function (text) {
          return toPrice(text);
        },
      },
    },
    xAxis: {
      label: {
        formatter: function (text) {
          return text;
        },
      },
    },
    tooltip: {
      formatter: function (datum) {
        return { name: datum.x, value: toPrice(datum.y) };
      },
    },
    label: {
      formatter: function (data) {
        return toPrice(data.y);
      },
    },
    point: {
      size: 2,
      shape: "circle",
      style: {
        fill: "#5B8FF9",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
    state: {
      active: {
        style: {
          shadowBlur: 4,
          stroke: "#000",
          fill: "red",
        },
      },
    },
    interactions: [
      {
        type: "marker-active",
      },
    ],
  };
  return <Area {...config} style={{ width: "100%" }} />;
};

export default SimpleArea;
